import React from 'react';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import styles from '../ProfileOptions/styles/styles';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { Badge } from '@material-ui/core/';
import ProfileOptionsHeader from './ProfileOptionsHeader';
import ProfileOptionsBody from './ProfileOptionsBody';
import { RootStateOrAny, useSelector } from 'react-redux';

enum BRANDS {
  BK = 'BK',
  TH = 'TH',
  PLK = 'PLK',
}

export default function ProfileOptions({
  handleClick,
  handleClose,
  handleLogout,
  userInfo,
  open,
  anchorEl,
  id,
}) {
  const { selectedBrand } = useSelector(
    (state: RootStateOrAny) => state.UIReducer,
  );
  let AvatarColor;
  const classes = styles();
  switch (selectedBrand) {
    case BRANDS.BK:
      AvatarColor = classes.brandBKAvatarColors;
      break;
    case BRANDS.TH:
      AvatarColor = classes.brandTHColors;
      break;
    case BRANDS.PLK:
      AvatarColor = classes.brandPLKAvatarColors;
      break;
    default:
      AvatarColor = classes.brandDefaultAvatarColors;
  }

  return (
    <div>
      <Badge variant="dot">
        <AccountCircleIcon onClick={handleClick} className={AvatarColor} />
      </Badge>
      <Popover
        open={open}
        id={id}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Typography className={classes.typography}>
          <ProfileOptionsHeader userInfo={userInfo} classes={classes} />
          <ProfileOptionsBody handleLogout={handleLogout} classes={classes} />
        </Typography>
      </Popover>
    </div>
  );
}
